module.exports = __webpack_public_path__ + "img/rights-title.7904e77c.png";